import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useFormContext } from 'react-hook-form';
import { FormControl, } from '@tribeplatform/react-ui-kit/FormControl';
export function Multiselect({ name, validation, error: ___, onChange: multiselectOnChange, value: __, ...rest }) {
    const { control } = useFormContext();
    return (_jsx(Controller, { control: control, name: name, rules: validation, render: ({ field: { onChange, value }, fieldState: { error } }) => (_jsx(FormControl.Multiselect, { name: name, invalid: !!(error === null || error === void 0 ? void 0 : error.message), error: error === null || error === void 0 ? void 0 : error.message, value: value, onChange: value => {
                onChange(value);
                if (typeof multiselectOnChange === 'function')
                    multiselectOnChange(value);
            }, ...rest }, void 0)) }, void 0));
}
//# sourceMappingURL=Multiselect.js.map